import moveConversations from './moveConversations';
import moveItems from './moveItems';
import { listViewStore } from 'owa-mail-list-store';
import { ActionSource, logUsage } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { getInboxClassificationFilterForTable } from 'owa-mail-list-store';

export default action('moveMailListRows')(async function moveMailListRows(
    rowKeys: string[],
    destinationFolderId: string,
    originalTableViewId: string,
    actionSource?: ActionSource
) {
    const originalTableView = listViewStore.tableViews.get(originalTableViewId);

    if (isInboxPlusEnabled() && folderNameToId('inbox') === originalTableView.tableQuery.folderId) {
        logUsage('InboxPlusMove', [getInboxClassificationFilterForTable(originalTableViewId)], {
            isCore: true,
        });
    }
    switch (originalTableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            await moveConversations(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;

        case ReactListViewType.Message:
            await moveItems(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;
    }
});
